import ApplyAllSignatureContainer from './applyAllSignatureContainer';
import './index.scss'
export default ApplyAllSignatureContainer;
